import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-35909d40"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item-bg"
}, null, -1));

const _hoisted_2 = ["onClick"];
import composition from '@/composition';
export default {
  props: {
    type: {
      type: Number,
      default: 0
    },
    order: {
      type: String,
      default: 'hotCount'
    } // 0 评论 2 帮办

  },
  emits: ['switchOrder'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      ref,
      store
    } = composition(); // 选择index

    const selectIndex = ref(0);
    const types = ref(['最热', '正序', '倒序']);
    let orders = ['hotCount', 'createTimeASC', ''];

    const changeType = index => {
      if (selectIndex.value == index) {
        return;
      }

      const order = orders[index];
      selectIndex.value = index;

      if (props.type == 0) {
        store.state.commentOrder = order;
      } else {
        emits('switchOrder', order);
      }
    };

    switch (props.type) {
      case 0:
        types.value = ['最热', '正序', '倒序'];
        orders = ['hotCount', 'createTimeASC', ''];
        break;

      case 2:
        // 帮办 
        types.value = ['最新', '最热', '附近'];
        orders = ['', 'hotCount', 'distance'];
        break;

      default:
        types.value = ['最新', '最热'];
        orders = ['', 'hotCount'];
        break;
    }

    const index = orders.findIndex(element => {
      return element == props.order;
    });
    selectIndex.value = index;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "types-view",
        style: _normalizeStyle({
          '--types-count': types.value.length
        })
      }, [_hoisted_1, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['item', selectIndex.value == index ? 'select-item' : '']),
          key: index,
          onClick: $event => changeType(index)
        }, _toDisplayString(item), 11, _hoisted_2);
      }), 128))], 4);
    };
  }

};